export const tracks = [
  {
    head: "Skyrocket effectiveness",
    text: "Know who's doing what and how it's going all the while eliminating distractions.",
  },
  {
    head: "Minimize business losses",
    text: "Get precise insights into projects to determine profitability and allocate resources.",
  },
  {
    head: "Automate team management",
    text: "Organize shifts, absences, and booking-related questions all in one place.",
  },
  {
    head: "Avoid burnout",
    text: "Take care of your team and eliminate overworking with break reminders and private time.",
  },
];

export const icons = [
  {
    img: "https://desktime.com/assets/img/clients/customer-sixt-logo-white.svg",
    alt: "ic1",
  },
  {
    img: "https://desktime.com/assets/img/clients/customer-mapon-logo-white.svg",
    alt: "ic2",
  },
  {
    img: "https://desktime.com/assets/img/clients/customer-montway-logo-white.svg",
    alt: "ic3",
  },
  {
    img: "https://desktime.com/assets/img/clients/customer-onthemap-logo-white.svg",
    alt: "ic4",
  },
  {
    img: "https://desktime.com/assets/img/clients/customer-printful-logo-white.svg",
    alt: "ic5",
  },
];
